import { User as UserType } from '@/types';
import { supabase } from '@/integrations/supabase/client';

export class User {
  static async me(): Promise<UserType> {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('Not authenticated');
    
    const { data: profile, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', user.id)
      .single();
    
    if (error) throw error;
    
    return {
      ...profile,
      full_name: profile.first_name && profile.last_name 
        ? `${profile.first_name} ${profile.last_name}` 
        : profile.first_name || profile.last_name || profile.email,
      role: profile.is_admin ? 'admin' : 'user'
    } as UserType;
  }

  static async filter(criteria: any): Promise<UserType[]> {
    let query = supabase.from('profiles').select('*');
    
    // Apply any filter criteria
    if (criteria.district_id) {
      query = query.eq('district_id', criteria.district_id);
    }
    
    const { data, error } = await query;
    
    if (error) throw error;
    
    return (data || []).map(profile => ({
      ...profile,
      full_name: profile.first_name && profile.last_name 
        ? `${profile.first_name} ${profile.last_name}` 
        : profile.first_name || profile.last_name || profile.email,
      role: profile.is_admin ? 'admin' : 'user'
    })) as UserType[];
  }

  static async get(id: string): Promise<UserType> {
    const { data: profile, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', id)
      .single();
    
    if (error) throw error;
    
    return {
      ...profile,
      full_name: profile.first_name && profile.last_name 
        ? `${profile.first_name} ${profile.last_name}` 
        : profile.first_name || profile.last_name || profile.email,
      role: profile.is_admin ? 'admin' : 'user'
    } as UserType;
  }

  static async update(id: string, data: Partial<UserType>): Promise<UserType> {
    const { data: updated, error } = await supabase
      .from('profiles')
      .update(data)
      .eq('id', id)
      .select()
      .single();
    
    if (error) throw error;
    
    return {
      ...updated,
      full_name: updated.first_name && updated.last_name 
        ? `${updated.first_name} ${updated.last_name}` 
        : updated.first_name || updated.last_name || updated.email,
      role: updated.is_admin ? 'admin' : 'user'
    } as UserType;
  }

  static async updateMyUserData(data: Partial<UserType>): Promise<UserType> {
    const user = await this.me();
    return this.update(user.id, data);
  }

  static async login(): Promise<void> {
    console.log('Login functionality not implemented');
  }
}